export default __webpack_public_path__ + "f6c39c6364ceaefde1c51b4fff02bb63.svg";